export default {"src":"/_next/static/media/atlas.ca5cff96.svg","height":26,"width":84,"blurWidth":0,"blurHeight":0};